import { useCallback, useState } from 'react';

const DISMISSED = 'dismissed';

const readDismissed = (storageKey: string): boolean => {
  try {
    return globalThis.sessionStorage?.getItem(storageKey) === DISMISSED;
  } catch {
    return false;
  }
};

/**
 * Remembers that the user closed a notice for the rest of this browser tab's
 * session. Storage can be unavailable (private mode, blocked site data), in
 * which case the notice is still hidden until the page reloads.
 */
export const useSessionDismissal = (storageKey: string) => {
  const [dismissed, setDismissed] = useState(() => readDismissed(storageKey));

  const dismiss = useCallback(() => {
    setDismissed(true);
    try {
      globalThis.sessionStorage?.setItem(storageKey, DISMISSED);
    } catch {
      // Storage unavailable — the in-memory state still hides it.
    }
  }, [storageKey]);

  return { dismissed, dismiss };
};
